import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Component, OnInit, Renderer2, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbModalConfig, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { DataTableDirective } from "angular-datatables";
import { CookieService } from "ngx-cookie-service";
import { Observable, Subject, Subscription } from "rxjs";
import { catchError, map, shareReplay } from "rxjs/operators";
import { breadcrumbItem } from "src/app/components/breadcrumbs/breadcrumbs.model";
import { TranslatePipe } from "src/app/core/pipes/translate.pipe";
import { AlertService } from "src/app/core/services/AlertService/alert.service";
import { CoreService } from "src/app/core/services/core/core.service";
import { CourseService } from "src/app/core/services/course.service";
import { CryptoService } from "src/app/core/services/crypto.service";
import { locationBroadcastService } from "src/app/core/services/loaction-broadcast.service";
import { PermissionService } from 'src/app/core/services/permission.service';
import { ApiService } from "src/app/services/api";
import { BreadcrumbService } from "src/app/services/breadcrumb";
import { TimezoneService } from "src/app/services/timezone";
import { AppState } from "src/app/store/app.state";
import { setLoadingSpinner } from "src/app/store/sharedstate/shared.actions";
import { environment } from "src/environments/environment";

@Component({
  selector: 'app-event-recommendations',
  templateUrl: './event-recommendations.component.html',
  styleUrls: ['./event-recommendations.component.scss'],
  providers: [TranslatePipe],
})
export class EventRecommendationsComponent implements OnInit {

    // Store the Request in Subscription for Better Performance
    private licenseSubscription:Subscription = null

    breadcrumbItems: breadcrumbItem[] = [
      {
        label: 'Home',
        active: false,
        url: "/home",
      },
      {
        label: 'Marketing Recommendation',
        active: true,
        url: "/event-recommendations",
      },
    ];

    dtOptions: DataTables.Settings = { paging: true };

    @ViewChild(DataTableDirective)

    datatableElement: DataTableDirective;
    dtTrigger: Subject<any> = new Subject();

    addShiftModalRef: NgbModalRef;
    addShiftForm: FormGroup;
    @ViewChild("addShift") addShift: TemplateRef<any>;
    // calendarOptions: CalendarOptions = {
    //   headerToolbar: {
    //     left: "prev,next today dayGridMonth,dayGridWeek,dayGridDay",
    //     center: "title",
    //     right: "requestTimeOff addShift",
    //   },
    //   customButtons: {
    //     // requestTimeOff: {
    //     //   text: "Request Time Off",
    //     //   click: () => this.openRequestTimeOffModal(),
    //     // },
    //     addShift: {
    //       text: "+ Add Shift",
    //       click: () => this.openAddShiftModal(),
    //     },
    //   },
    //   plugins: [dayGridPlugin],
    //   initialView: "dayGridMonth",
    //   themeSystem: "bootstrap5",
    //   weekends: true,
    //   editable: false,
    //   selectable: true,
    //   selectMirror: false,
    //   dayMaxEvents: true,
    //   displayEventEnd: true,
    //   eventDisplay: "block",
    //   dateClick: this.handleDateClick.bind(this),
    //   // dateClick: this.openModal.bind(this),
    //   eventClick: this.handleEventClick.bind(this),
    //   // eventsSet: this.handleEvents.bind(this),
    //   eventTimeFormat: {
    //     // like '14:30:00'
    //     hour: "numeric",
    //     minute: "numeric",
    //     meridiem: true,
    //     hour12: true,
    //   },
    //   timeZone: localStorage.getItem('Timezone'),

    //   events: this.calendarEvents,

    // };
    public rangestartDate: any = this.timezoneService
    .get()()
    .startOf("week")
    .add("day", 1);
  public rangeendDate: any = this.timezoneService
    .get()()
    .endOf("week")
    .add("day", 1);
  public rangestartDateDisplay: any = this.rangestartDate.format("MM/DD/YYYY");
  public rangeendDateDisplay: any = this.rangeendDate.format("MM/DD/YYYY");
  public daterangeOptions: any = {
    parentEl: "#daterangeBody",
    locale: { format: "MM/DD/YYYY", firstDay: 1 },
    startDate: this.rangestartDateDisplay,
    endDate: this.rangeendDateDisplay,
    alwaysShowCalendars: true,
    // dateLimit: {
    //   days: 6,
    // },
    singleDatePicker: false,
  };

    // grettings: any = "Schedule";
    checkedAll: any = false;

    eventStartDate = this.timezoneService.get()().startOf("day").format("MM/DD/YYYY");
    eventEndDate = this.timezoneService.get()().add(7, 'days').endOf('day').format("MM/DD/YYYY");
    Apikey: any;
    // colorOptions: Object = { color: "#f0b518" };
    detectChanges: boolean = true;
    value: string;
    storeId: any = "";
    GLOBALURL: string;
    // course = null;
    settings = null;

    // PAGINATION
    isSearch: boolean = false
    isEmpty: boolean = false
    offset: any;
    totalLicenses: any = 0;
    licenses: any = [];
    eventsList = []
    allEventsList = []
    limit: any;

    isAllModfiersFetched = false;
    params: any = new HttpParams();
    params2: any = new HttpParams();
    licenseId: any = "";



    headerToken = { 'Content-Type': 'application/json', 'Authorization': this.cookieService.get('token') }
    httpOptions = { headers: new HttpHeaders(this.headerToken) };
    httpOptionsEvents = { headers: new HttpHeaders(this.headerToken) };
    httpOptions4 = {};

    selected: { id: any; text: string; currency: string; currencyCode: string; logo: string };

    constructor(
      private cookieService: CookieService,
      private locService: locationBroadcastService,
      public http: HttpClient,
      private toastr: AlertService,
      public router: Router,
      public route: ActivatedRoute,
      private store: Store<AppState>,
      private modalConfig: NgbModalConfig,
      private modalService: NgbModal,
      private courseService: CourseService,
      private ApiService: ApiService,
      private BreadcrumbService: BreadcrumbService,
      private timezoneService: TimezoneService,
      private coreService: CoreService,
      public permissionService: PermissionService,
      private cryptoService: CryptoService,
      private renderer: Renderer2,
      private fb: FormBuilder,
      ) {
      this.GLOBALURL = this.ApiService.getBaseURL();
      this.addShiftForm = fb.group({
        endDate: ["", Validators.required],
        startDate: ["", Validators.required],
        country: ["", Validators.required],
        state: [""],
        city: [""],
        // status: [1],
      });
    }

    ngOnInit(): void {
      this.store.dispatch(setLoadingSpinner({ status: true }));
      // this.getApiKey();
      this.BreadcrumbService.setValue(this.breadcrumbItems);

      if (this.cookieService.get("superAdminPage") !== "3") {
        this.toastr.error('Logged-in account should be a Super Admin.')
        this.router.navigate(['/home']);
        return;
      }
      this.addShiftForm.controls.startDate.setValue(
        this.timezoneService.get()(this.rangestartDate).unix().toString()
      );
      this.addShiftForm.controls.endDate.setValue(
        this.timezoneService.get()(this.rangeendDate).unix().toString()
      );
      this.rangestartDateDisplay = this.rangestartDate.format("MM/DD/YYYY");
      this.rangeendDateDisplay = this.rangeendDate.format("MM/DD/YYYY");
      this.addShiftForm.controls.startDate.setValue(this.rangestartDateDisplay);
      this.addShiftForm.controls.endDate.setValue(this.rangeendDateDisplay);
      // if (!this.permissionService.canAccessSuper('License', 1)) {
      //   this.toastr.error("You are not authorized to perform this operation.");
      //   this.router.navigate(['/overview']);
      //   return;
      // }

      // this.dtOptions = {
      //     pageLength: 50,
      //   language: {
      //     searchPlaceholder: "Search By License Key",
      //     search: "",
      //     emptyTable: "No License Available in Table",
      //   },
      //   searching: false,
      //   scrollX: true,
      //   ordering: false,
      //   dom: '<"top my-custom-class"f>t<"bottom"lip>',
      //   paging: true,
      //   initComplete: function() {
      //     $('.my-custom-class').css('marginBottom', '10px');
      //   },
      //   pagingType: 'simple_numbers',
      //   serverSide: true,
      //   processing: false,
      // };
      // this.dtOptions = {
        // pageLength: 50,
        // language: {
        //   searchPlaceholder: "Search By License Key",
        //   search: "",
        //   emptyTable: "No License Available in Table",
        // },
        // searching: false,
        // scrollX: true,
        // ordering: false,
        // dom: '<"top my-custom-class"f>t<"bottom"lip>',
        // paging: true,
        // initComplete: function() {
        //   $('.my-custom-class').css('marginBottom', '10px');
        // },
        // pagingType: 'simple_numbers',
        // serverSide: true,
        // processing: false,
        // ajax: (dataTablesParameters: any, callback) => {
          this.store.dispatch(setLoadingSpinner({ status: true }));
          //objectToHttpParams added outside ngonit
          // const params: any = this.coreService.objectToHttpParams(dataTablesParameters);

          // reset http query params
          this.params = new HttpParams();

          this.value = this.cookieService.get("token");
          this.storeId = this.cookieService.get("storeId");


          this.store.dispatch(setLoadingSpinner({ status: true }));
          this.http
          // .post("https://api.openai.com/v1/chat/completions", reqParams2, httpOptions)
          // .pipe(
          //   map((data) => {
          //     return data;
          //   })
          // )
          .get(this.GLOBALURL + "/credentialsv2", {
            headers: new HttpHeaders({
              "Content-Type": "application/json",
              Authorization: this.cookieService.get("token"),
            }),
            params: new HttpParams().set("env", environment.env),
          }).pipe(
            map((response: any) => {
              this.store.dispatch(setLoadingSpinner({ status: true }));
              // this.isEmpty = true
              // this.store.dispatch(setLoadingSpinner({ status: false }));
              // this.getRecommendations()
              this.Apikey = response.response.filter((x: any) => x.name === "chatGptKey")[0].value;
              this.Apikey = this.cryptoService.decrypt(this.Apikey)
              // this.googleApiKey = response.response.filter((x: any) => x.name === "googleApiKey")[0].value;
              this.httpOptionsEvents = {
                headers: new HttpHeaders({
                  Authorization: `Bearer ${this.Apikey}`,
                }),
              };
              return this.Apikey;  // Optionally return the API key
            }),
            catchError(error => error),
            shareReplay(1)  // Ensure the observable is shared and replay the last emitted value
          )
          .subscribe(
            (response: any) => {
              this.getRecommendations()
              // this.isEmpty = true
              // console.log("this.isEmpty", this.isEmpty)
              // this.store.dispatch(setLoadingSpinner({ status: false }));
            },
            (error) => {
              this.isEmpty = true
              const message = this.ApiService.errorMessage(error)
              this.toastr.error(message);
              this.reload();
              this.store.dispatch(setLoadingSpinner({ status: false }));
            }
          );

          // return this.licenseSubscription;
      //   },
      // };


      this.modalConfig.backdrop = "static";
      this.modalConfig.keyboard = false;
      // this.params = new HttpParams();
      // this.getNumberCountLicenses();
      // this.getStoresFunction();
      // check if user is allowed to visit the page
      //  if (this.cookieService.get("superAdminPage") === "3") {

      //   this.value = this.cookieService.get("token");
      //   this.storeId = this.cookieService.get("storeId");
      //   this.getNumberCountLicenses();
      //   this.getStoresFunction();
      // } else {
      //   this.router.navigate(["/home"]);
      // }
    }

    processLicenses(response: any): { licenses: any[], copyLicensesData: any[] } {
      const licenses = [];
      const copyLicensesData = [];

      response.response.forEach(element => {
        element.newKey = this.chunk(element.key, 6).join('-');
        licenses.push(element);
        copyLicensesData.push(Object.assign({}, element));
      });

      this.sortByName(licenses, 'createdAt', true);
      this.sortByName(copyLicensesData, 'createdAt', false);

      return { licenses, copyLicensesData };
    }

    navigateUpdateLicense(id){
      // if (this.storeId === "*") {
      //     this.toastr.clear();
      //     this.toastr.error("Please select a location first.");
      //     return;
      //   }

        this.router.navigate(["./update", id], { relativeTo: this.route });
    }
    // deleteLicense(id){
    //     this.router.navigate(["./delete", id], { relativeTo: this.route });
    // }
    cancelDeleteAll(content) {
      this.modalService.dismissAll(content);
    }
    open(content , licenseId) {
      this.licenseId = licenseId;
      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
    }
    resultProductIds: any = [];
    productIds: any = "";
    deleteBtnFlag = false;
    httpOptions3: any = {};

    reload() {
      // save current route first
      const currentRoute = this.router.url;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = "reload";
      this.router.navigate([currentRoute]);
    }

    // Optimized Refresh Datatable Using AJAX
    refreshDataTable() {
      if (this.datatableElement) {
        this.datatableElement?.dtInstance.then((dtInstance: DataTables.Api) => {
          // Reload the table data from the Ajax data source
          dtInstance.ajax.reload((json) => {
            console.log("dtinstance_FROM_AJAX", dtInstance.data(), dtInstance.page.info(), json);
            // If the response data is empty, go to the first page
            if (json.response.length === 0 && dtInstance.page.info().page > 0) {
              console.log("Data table refreshed and going to first page")
              dtInstance.page('first').draw('page');
            }
          }, false); // Pass false to keep the current paging position
          console.log("Data table refreshed");
        });
      }
    }

    deleteLicense(content) {
      var params = {
        subscriptionId: this.licenseId,
      };
      this.httpOptions3 = {
        headers: new HttpHeaders(this.headerToken),
        params: params,
      };
      this.detectChanges = true;
      return this.http
        .delete(this.GLOBALURL + "/subscriptionToken", this.httpOptions3)
        .subscribe(
          (response: any) => {
            if (response.success == 0) {
              this.toastr.error(response.message);
            } else {
              this.detectChanges = true;
              this.toastr.success(response.message);
              this.modalService.dismissAll(content);
              this.checkedAll = false;
              this.deleteBtnFlag = false;
              // setTimeout(() => {
                this.toastr.success(response.message);
              // }, 4000);
              // this.reload();
              this.refreshDataTable();
            }
          },
          (error) => {
            const message = this.ApiService.errorMessage(error);
            this.toastr.error(message);
            this.modalService.dismissAll(content);
          }
        );
    }

    copylicense(val){
      let selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = val;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      this.toastr.success("Copied")
    }

      endDate: any = this.timezoneService.get()().endOf('day');
      expirationDate: any = this.endDate.unix();
      endDateDisplayFormatted: any = this.timezoneService.get().unix(this.expirationDate).format("MMM Do YYYY");


    showClearBtn: any = false;
    searchName: any = '';
    copyLicensesData:any = [];
    locations: any = [];

    getStoresFunction() {
      let headerToken = { "Content-Type": "application/json", Authorization: this.cookieService.get("token") };
      let httpOptions = { headers: new HttpHeaders(headerToken) };
      if (this.cookieService.get("superAdminPage") === "3") {
          this.locations = [{ id: "*", text: "All Locations", currency: "$", currencyCode: "", logo: "" }];
      }
      return this.http.get(this.GLOBALURL + "/store", this.httpOptions).subscribe((response: any) => {
          if (response.success == 0) {
              this.toastr.error(response.message);
          } else {
              console.log(response)
              response.response.forEach(element => {
                  if (element.status == 1) {
                      this.locations.push({ id: element.storeId, text: element.storeName, currency: this.getCurrency(element), currencyCode: "", logo: element.storeLogo });
                  }
              });
          }
          localStorage.setItem("locations", JSON.stringify(this.locations));
          this.getSelected();
      },
          error => {
            const message = this.ApiService.errorMessage(error)
              this.toastr.error(message);
          });
  }

  getSelected() {
      var id = this.cookieService.get("storeId");
      if (id !== "*") {
          for (let index = 0; index < this.locations.length; index++) {
              if (this.locations[index].id === id) {
                  this.http.get(this.GLOBALURL + "/settings?storeId=" + id, this.httpOptions).subscribe((response: any) => {
                      if (response.success == 0) {
                          this.toastr.error(response.message);
                      } else {
                          response.response.forEach(element2 => {
                              if (element2.settingName == 'Currency') {
                                  var currencyCode = element2.settingValue.replace(/ /g, "").split('-');
                                  this.locations[index].currency = currencyCode[1];
                              }
                          });
                      }
                  },
                      error => {
                          const message = this.ApiService.errorMessage(error)
                          this.toastr.error(message);
                      });
                  this.selected = this.locations[index];
                  this.cookieService.set('storeName', this.selected.text);
                  this.cookieService.set('logo', this.selected.logo);
                  this.cookieService.set('currency', this.selected.currency?this.selected.currency:'');
                  this.cookieService.set('currencyCode', this.selected.currencyCode);
                  localStorage.setItem('currency', this.selected.currency);
                  break;
              } else {
                  this.selected = this.locations[0];
                  this.cookieService.set('logo', this.selected.logo);
                  this.cookieService.set('storeName', "All Locations");
                  this.cookieService.set('currency', '$');
                  this.cookieService.set('currencyCode', '');
                  localStorage.setItem('currency', '$');
              }
          }
      } else {
          localStorage.setItem('currency', '$');
          this.selected = this.locations[0];
      }
  }

  getCurrency = (storeInformation) => {
      const currentCurrency = this.findSetting(storeInformation, 'Currency');
      const currency = currentCurrency.replace(/ /g, "").split('-');
      return currency[1];
  }

  findSetting = (storeInformation, settingName) => {
      const settingExist = storeInformation.settings.find((setting) => {
          return setting.settingName === settingName;
      });
      if (settingExist === undefined) {
          return 'false';
      }
      return storeInformation.settings.filter((setting) => {
          return setting.settingName === settingName;
      })[0].settingValue;
  }



  // offset: any = 0;
  // totalLicenses: any = 0;
  // licenses: any = [];
  getNumberCountLicenses() {
      this.licenses = [];
      this.copyLicensesData = [];
      return this.http.get(this.GLOBALURL + '/subscription/list', this.httpOptions).subscribe((response: any) => {
          if (response.success == 0) {
              this.toastr.error(response.message);
          } else {
              this.totalLicenses = response.response.length;
              this.offset = 0;
              // var params = this.params.set("offset", this.offset)
              this.httpOptions2 = { headers: new HttpHeaders(this.headerToken), params: this.params };
              this.getLicensesFunction();
          }
      }, (error) => {
          const message = this.ApiService.errorMessage(error)
          this.toastr.error(message);
      });
  }

  httpOptions2: any = {};
  getLicensesFunction() {
      this.licenses = [];
      this.copyLicensesData = [];
      for (this.offset; this.offset < this.totalLicenses; this.offset += 100) {
          return this.http.get(this.GLOBALURL + '/subscription/list', this.httpOptions).subscribe((response: any) => {
              if (response.success == 0) {
                  alert(response.message);
              } else {
                  response.response.forEach(element => {
                      element.newKey = this.chunk(element.key, 6).join('-')
                      this.licenses.push(element);
                      this.copyLicensesData.push(Object.assign({}, element));
                  });
                  this.sortByName(this.licenses, 'createdAt', true);
                  this.sortByName(this.copyLicensesData, 'createdAt', false);
              }
          }, (error) => {
              const message = this.ApiService.errorMessage(error)
              this.toastr.error(message);
          });
      }
  }


  chunk(str, n) {
      var ret = [];
      var i;
      var len;
      for (i = 0, len = str.length; i < len; i += n) {
          ret.push(str.substr(i, n))
      }
      return ret
  };

  // getExpirationDate(e) {
  //     console.log(e);
  // }

  sortByName(arr, attr, order) {
      if (order) {
          order = false;
      } else {
          order = true;
      }
      return arr.sort((first, second) => {
          if (first[attr] > second[attr]) {
              if (order) {
                  return 1;
              } else {
                  return -1;
              }
          } else if (first[attr] < second[attr]) {
              if (order) {
                  return -1;
              } else {
                  return 1;
              }
          }
      })
  }

  itemsPP: any = 10;
  p: any = 1;
  onLimitSelected(e) {
      this.itemsPP = e;
  }

  public select(value: any) {
  this.endDate = value.end;
      this.expirationDate = this.endDate.unix();
  this.endDateDisplayFormatted = this.timezoneService.get().unix(this.expirationDate).format("MMM Do YYYY");
  }
  // numberMask = createNumberMask({
  //   suffix: '',
  //   prefix: '',
  //   allowDecimal: false,
  //   includeThousandsSeparator: false,
  // })

  goToAddPage() {

      this.router.navigate(['/licenses/new'])

    }

    getRecommendations() {
      this.http.get(this.GLOBALURL + "/recommendations", {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"), // Ensure this gets a valid token
        }),
        // params: new HttpParams().set("env", environment.env), // Add or modify params as needed
      }).subscribe(
        (response: any) => {
          if (response.success === 0) {
            this.allEventsList = [];
            this.isEmpty = true
            console.log("this.isEmpty", this.isEmpty)
            this.store.dispatch(setLoadingSpinner({ status: false }));
            // Handle a failed response
            this.toastr.error('Failed to fetch recommendations.');
          } else {
            // Process the fetched recommendations
            this.allEventsList = response.response || [];
            this.isEmpty = false
            console.log("this.isEmpty", this.isEmpty)
            this.store.dispatch(setLoadingSpinner({ status: false }));
            console.log('Recommendations fetched successfully:', response.response);
            this.toastr.success(response.message);
          }
        },
        (error) => {
          // Handle errors
          this.allEventsList = [];
          this.isEmpty = true
              console.log("this.isEmpty", this.isEmpty)
              this.store.dispatch(setLoadingSpinner({ status: false }));
          const message = this.ApiService.errorMessage(error);
          this.toastr.error(message);
          console.error('Error fetching recommendations:', error);
        }
      );
    }

    onActiveStatusChange(license, event) {
      const payload = {
        eventId: license.eventId,
        status: license.status === 1 ? 2 : 1,
      };

      this.http.put(this.GLOBALURL + "/recommendations", payload, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
      })
        .subscribe((response: any) => {
          if (response.success == 0) {
            this.toastr.error('Failed to save an event.');
          } else {
            // this.eventsList.push(response.response);
            this.toastr.error(response.message);
            setTimeout(() => {
              this.reload()
            }, 1000);

          }
        }, (error) => {
          // this.toastr.error('Failed to save an event, continuing with the next');
          const message = this.ApiService.errorMessage(error)
          this.toastr.error(message);

        });
    }

  apiKey$: Observable<any>

  getApiKey(): Observable<any> {
    if (!this.apiKey$) {
      this.apiKey$ = this.http.get(this.GLOBALURL + "/credentialsv2", {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
        params: new HttpParams().set("env", environment.env),
      }).pipe(
        map((response: any) => {
          this.isEmpty = true
          this.store.dispatch(setLoadingSpinner({ status: false }));
          this.Apikey = response.response.filter((x: any) => x.name === "chatGptKey")[0].value;
          this.Apikey = this.cryptoService.decrypt(this.Apikey)
          // this.googleApiKey = response.response.filter((x: any) => x.name === "googleApiKey")[0].value;
          this.httpOptionsEvents = {
            headers: new HttpHeaders({
              Authorization: `Bearer ${this.Apikey}`,
            }),
          };
          return this.Apikey;  // Optionally return the API key
        }),
        catchError(error => error),
        shareReplay(1)  // Ensure the observable is shared and replay the last emitted value
      );
    }
    return this.apiKey$;
  }

  getLocation = (): string => {
    try {
        // Try to get the location from cookies
        let location = this.cookieService.get("storeCountry");

        // If not found in cookies, try local storage
        if (!location) {
            location = localStorage.getItem("storeCountry");
        }

        // If still not found, default to "United States"
        if (!location) {
            location = 'United States';
        }

        return location;
    } catch (error) {
        console.error('Error retrieving location:', error);
        // Fallback to "United States" in case of any error
        return 'United States';
    }
};

get addShiftFormValues() {
  return this.addShiftForm.controls;
}

rangeselectedDate(value: any) {
  this.renderer.removeClass(document.body, 'modal-edit-address')
  this.renderer.removeClass(document.body, 'modal-edit-address')
  this.renderer.addClass(document.body, "modal-edit-address");

  this.rangestartDate = value.start;
  this.rangeendDate = value.end;
  this.rangestartDateDisplay = this.rangestartDate.format("MM/DD/YYYY");
  this.rangeendDateDisplay = this.rangeendDate.format("MM/DD/YYYY");

  this.daterangeOptions= {
    parentEl: "#daterangeBody",
    locale: { format: "MM/DD/YYYY", firstDay: 1 },
    startDate: this.rangestartDate,
    endDate: this.rangeendDate,
    alwaysShowCalendars: true,
    // dateLimit: {
    //   days: 6,
    // },
    singleDatePicker: false,
  };

  this.addShiftForm.controls.startDate.setValue(this.rangestartDateDisplay);
  this.addShiftForm.controls.endDate.setValue(this.rangeendDateDisplay);
  // this.addShiftForm.controls.startDate.setValue(moment(this.rangestartDate).unix().toString())
  // this.addShiftForm.controls.endDate.setValue(moment(this.rangeendDate).unix().toString())
  setTimeout(() => {
    this.renderer.removeClass(document.body, 'ng-tns-0-0');
  }, 2000);
}

/**
   * Dismiss Add Shift Modal
   */
dismissAddShiftModal() {
  // console.log("EMPLOYEE ID 0", this.employeeId);
  // Some times employeeId is null after line 1469, we need to store it in a temp variable
  // let tempId = this.employeeId;
  this.addShiftModalRef.dismiss();
  // this.addShiftForm.reset();
  this.addShiftForm.reset();
              this.rangestartDate = this.timezoneService
                .get()()
                .startOf("week")
                .add("day", 1);
              this.rangeendDate = this.timezoneService
                .get()()
                .endOf("week")
                .add("day", 1);
              this.rangestartDateDisplay =
                this.rangestartDate.format("MM/DD/YYYY");
              this.rangeendDateDisplay = this.rangeendDate.format("MM/DD/YYYY");
              // this.startdateFormatted = new Date();
              this.addShiftForm.controls.startDate.setValue(
                this.timezoneService
                  .get()(this.rangestartDate)
                  .unix()
                  .toString()
              );
              this.addShiftForm.controls.endDate.setValue(
                this.timezoneService.get()(this.rangeendDate).unix().toString()
              );
  // Assign the value back to employeeId
  // this.employeeId = tempId;
  // this.addShiftForm.controls.employeeId.patchValue(tempId);
  // console.log("EMPLOYEE ID 1", this.employeeId);
}

openAddShiftModal() {
  // this.newEventDate = event;
  this.addShiftModalRef = this.modalService.open(this.addShift, {
    centered: true,
  })

  this.addShiftModalRef.result.then(() => {
    this.renderer.removeClass(document.body, 'modal-edit-shift')
  },
  () => {
    this.renderer.removeClass(document.body, 'modal-edit-shift')
  })

  this.renderer.addClass(document.body, "modal-edit-shift");

  return null;
}

isValidTimeEndTime: boolean
isGenerateFormValid = false;
onSubmitAddShift() {
  // this.addShiftForm.markAllAsTouched();
  if (!this.addShiftForm.valid) {
    // this.toastr.error('Please enter details...');
    // this.isGenerateFormValid = false
    this.addShiftForm.markAllAsTouched();
    return;
  }
  // this.isLoading = !this.isLoading;
  let data = this.addShiftForm.value;
  console.log("this.addShiftForm.value", this.addShiftForm.value);
  // console.log("this.addShiftForm.controls", this.addShiftForm.controls);
  if (this.addShiftForm.valid) {
    this.dismissAddShiftModal()
    this.store.dispatch(setLoadingSpinner({ status: true }));
    this.eventsList = [];
    console.log("data", data);
    let { startDate, endDate, country, state, city } = data;
    // console.log("OBJ: AFTER", obj);

        this.value = this.cookieService.get("token");
        this.storeId = this.cookieService.get("storeId");
        // const location = this.getLocation();
        let location = country;
if (state) {
    location += `, ${state}`;
}
if (city) {
    location += `, ${city}`;
}

        let httpOptions = {
          headers: new HttpHeaders({
            // Authorization: `Bearer ${this.Apikey}`,
            Authorization: `Bearer ${this.Apikey}`,
          }),
        };

          let reqParams2 = {
            model: "gpt-4",
            // messages: [
            //     { role: "system", content: "You are a creative assistant with knowledge of festivals and scheduling." },
            //     {
            //       role: "user",
            //       content: `Provide a JSON array of upcoming festivals between ${startDate} and ${endDate} at the ${location} location. Each JSON object should include the following fields with exact property names: name as title of the festival, startdate, enddate, status as 1 to indicate active, expirationdate, description, country as "${country}", state as "${state || ''}", and city as "${city || ''}". Dates should be in MM/DD/YYYY format. Ensure that the format is precise and clear JSON array with no additional text.`
            //     }
            //   ],
            messages: [
              {
                role: "system",
                content: "You are a knowledgeable and creative assistant with expertise in scheduling and providing details of annual festivals around the globe."
              },
              {
                role: "user",
                content: `Please provide a JSON array of annual festivals between ${startDate} and ${endDate} occurring in ${location}. Each JSON object should include precise and well-known festivals with the following fields and exact property names: name for the festival's official title, startdate, enddate, status as 1 to indicate active, expirationdate, description in one line, country as "${country}". Ensure the response is a clean JSON array with no extra commentary or text.`
              }
            ],
            // , state as "${state || ''}", and city as "${city || ''}"
            temperature: 0.7,
            max_tokens: 1000,
            top_p: 0.9, // 1
            frequency_penalty: 0.1,
            presence_penalty: 0,
        };
          this.http
        .post("https://api.openai.com/v1/chat/completions", reqParams2, httpOptions)
        .pipe(
          map((data: any) => {
            return data;
          })
        ).subscribe( (mappedData: any) => {
          console.log("THIS_IS_SUBSCRIBE-GPT_RESPONSE")
          // this.store.dispatch(setLoadingSpinner({ status: false }));
          try {
            const events = mappedData["choices"][0].message.content;
            if (!events) {
              this.addShiftForm.reset();
              this.rangestartDate = this.timezoneService
                .get()()
                .startOf("week")
                .add("day", 1);
              this.rangeendDate = this.timezoneService
                .get()()
                .endOf("week")
                .add("day", 1);
              this.rangestartDateDisplay =
                this.rangestartDate.format("MM/DD/YYYY");
              this.rangeendDateDisplay = this.rangeendDate.format("MM/DD/YYYY");
              // this.startdateFormatted = new Date();
              this.addShiftForm.controls.startDate.setValue(
                this.timezoneService
                  .get()(this.rangestartDate)
                  .unix()
                  .toString()
              );
              this.addShiftForm.controls.endDate.setValue(
                this.timezoneService.get()(this.rangeendDate).unix().toString()
              );
              throw new Error('Unexpected response format: No content found.');
            }
            const eventList = JSON.parse(events);
            // const events = JSON.parse(mappedData["choices"][0].message.content || '[]');
        // if (!events.length) {
        //   throw new Error('No events found');
        // }
            if (!eventList || eventList?.length <= 0) {
              this.isEmpty = true;
              this.toastr.error('No Upcoming Events');
              this.addShiftForm.reset();
              this.rangestartDate = this.timezoneService
                .get()()
                .startOf("week")
                .add("day", 1);
              this.rangeendDate = this.timezoneService
                .get()()
                .endOf("week")
                .add("day", 1);
              this.rangestartDateDisplay =
                this.rangestartDate.format("MM/DD/YYYY");
              this.rangeendDateDisplay = this.rangeendDate.format("MM/DD/YYYY");
              // this.startdateFormatted = new Date();
              this.addShiftForm.controls.startDate.setValue(
                this.timezoneService
                  .get()(this.rangestartDate)
                  .unix()
                  .toString()
              );
              this.addShiftForm.controls.endDate.setValue(
                this.timezoneService.get()(this.rangeendDate).unix().toString()
              );
              // this.reload();
              this.store.dispatch(setLoadingSpinner({ status: false }));
            } else {
              this.addShiftForm.reset();
              this.rangestartDate = this.timezoneService
                .get()()
                .startOf("week")
                .add("day", 1);
              this.rangeendDate = this.timezoneService
                .get()()
                .endOf("week")
                .add("day", 1);
              this.rangestartDateDisplay =
                this.rangestartDate.format("MM/DD/YYYY");
              this.rangeendDateDisplay = this.rangeendDate.format("MM/DD/YYYY");
              // this.startdateFormatted = new Date();
              this.addShiftForm.controls.startDate.setValue(
                this.timezoneService
                  .get()(this.rangestartDate)
                  .unix()
                  .toString()
              );
              this.addShiftForm.controls.endDate.setValue(
                this.timezoneService.get()(this.rangeendDate).unix().toString()
              );
              this.store.dispatch(setLoadingSpinner({ status: true }));
              // this.eventsList = eventList;
              // this.isEmpty = false;
              console.log("this.eventsList", eventList)
              // this.eventsList = eventList;
              // this.isEmpty = false;
              const enrichedEvents = eventList.map(event => ({
                ...event,
                // country: country,  // Country from user input
                state: state || '',  // Default to empty if not provided
                city: city || ''     // Default to empty if not provided
              }));
              this.saveEventsSequentially(enrichedEvents);
              // return;
            }
          } catch (error) {
            console.error('Error processing OpenAI response:', error);
            this.isEmpty = true;
            this.store.dispatch(setLoadingSpinner({ status: false }));
            this.addShiftForm.reset();
              this.rangestartDate = this.timezoneService
                .get()()
                .startOf("week")
                .add("day", 1);
              this.rangeendDate = this.timezoneService
                .get()()
                .endOf("week")
                .add("day", 1);
              this.rangestartDateDisplay =
                this.rangestartDate.format("MM/DD/YYYY");
              this.rangeendDateDisplay = this.rangeendDate.format("MM/DD/YYYY");
              // this.startdateFormatted = new Date();
              this.addShiftForm.controls.startDate.setValue(
                this.timezoneService
                  .get()(this.rangestartDate)
                  .unix()
                  .toString()
              );
              this.addShiftForm.controls.endDate.setValue(
                this.timezoneService.get()(this.rangeendDate).unix().toString()
              );
            // const message = this.ApiService.errorMessage(error)
            this.toastr.error('Something went wrong, please try again...');
            // this.reload();
          }
        },
          (error) => {
            this.isEmpty = true
            this.store.dispatch(setLoadingSpinner({ status: false }));
            this.addShiftForm.reset();
              this.rangestartDate = this.timezoneService
                .get()()
                .startOf("week")
                .add("day", 1);
              this.rangeendDate = this.timezoneService
                .get()()
                .endOf("week")
                .add("day", 1);
              this.rangestartDateDisplay =
                this.rangestartDate.format("MM/DD/YYYY");
              this.rangeendDateDisplay = this.rangeendDate.format("MM/DD/YYYY");
              // this.startdateFormatted = new Date();
              this.addShiftForm.controls.startDate.setValue(
                this.timezoneService
                  .get()(this.rangestartDate)
                  .unix()
                  .toString()
              );
              this.addShiftForm.controls.endDate.setValue(
                this.timezoneService.get()(this.rangeendDate).unix().toString()
              );
            const message = this.ApiService.errorMessage(error)
            this.toastr.error(message);
            // window.location.reload()
            // Reload the page
            // this.reload();
          })

        // return this.licenseSubscription;
  } else {
    this.isEmpty = true
    this.toastr.error('Invalid details...');
    // this.addShiftForm.reset();
    this.addShiftForm.reset();
              this.rangestartDate = this.timezoneService
                .get()()
                .startOf("week")
                .add("day", 1);
              this.rangeendDate = this.timezoneService
                .get()()
                .endOf("week")
                .add("day", 1);
              this.rangestartDateDisplay =
                this.rangestartDate.format("MM/DD/YYYY");
              this.rangeendDateDisplay = this.rangeendDate.format("MM/DD/YYYY");
              // this.startdateFormatted = new Date();
              this.addShiftForm.controls.startDate.setValue(
                this.timezoneService
                  .get()(this.rangestartDate)
                  .unix()
                  .toString()
              );
              this.addShiftForm.controls.endDate.setValue(
                this.timezoneService.get()(this.rangeendDate).unix().toString()
              );
    this.store.dispatch(setLoadingSpinner({ status: false }));
  }
}

saveEventsSequentially(events: any[]) {
  if (!events || events.length === 0) {
    if(this.eventsList?.length > 0) {
      this.isEmpty = false; // Set after processing all events
      this.toastr.success('Events saved successfully!');
    } else {
      this.isEmpty = true;
    }
    // this.addShiftForm.reset();
    this.addShiftForm.reset();
              this.rangestartDate = this.timezoneService
                .get()()
                .startOf("week")
                .add("day", 1);
              this.rangeendDate = this.timezoneService
                .get()()
                .endOf("week")
                .add("day", 1);
              this.rangestartDateDisplay =
                this.rangestartDate.format("MM/DD/YYYY");
              this.rangeendDateDisplay = this.rangeendDate.format("MM/DD/YYYY");
              // this.startdateFormatted = new Date();
              this.addShiftForm.controls.startDate.setValue(
                this.timezoneService
                  .get()(this.rangestartDate)
                  .unix()
                  .toString()
              );
              this.addShiftForm.controls.endDate.setValue(
                this.timezoneService.get()(this.rangeendDate).unix().toString()
              );
    this.store.dispatch(setLoadingSpinner({ status: false }));
    console.log("ALL-EVENTS_SAVED_DB")
    return;
  }

  const event = events.shift(); // Take the first event
  console.log("SAVING_THIS_EVENT_NOW", event)

  this.http.post(this.GLOBALURL + "/recommendations", event, {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: this.cookieService.get("token"),
    }),
  })
    .subscribe((response: any) => {
      if (response.success == 0) {
        console.log("THIS_EVENT_NOT_SAVED_IN_DB")
      } else {
        this.allEventsList.push(response.response);
      }
      // this.toastr.success('Event saved successfully!');
      this.saveEventsSequentially(events); // Recursively call for the next event
    }, (error) => {
      // this.toastr.error('Failed to save an event, continuing with the next');
      console.error('Error saving event:', error);
      this.saveEventsSequentially(events); // Continue with others on error
    });
}

// reload() {
//   // save current route first
//   const currentRoute = this.router.url;
//   this.router.routeReuseStrategy.shouldReuseRoute = () => false;
//   this.router.onSameUrlNavigation = "reload";
//   this.router.navigate([currentRoute]);
// }

    // Destroy the Subscription
    ngOnDestroy() {
      if (this.licenseSubscription !== null) {
        this.licenseSubscription.unsubscribe();
      }
    }
  }
